class ContactConst {
    static Refresh = 'refresh';
    static Call = 'call';
    static Meeting = 'meeting';
    static Document = 'document';
    static SMS = 'sms';
    static Email = 'email';
    static WhatsApp = 'whats-app';
    static SalesOrder = 'sales-order';
    static Property = 'property';
}
export default ContactConst;